export default "__VITE_ASSET__Cai2N4Qo__"